import React from 'react';

import Content from '@components/Dashboard/AdminPanel/Timezone';

const Timezone: React.FC = () => {
  return <Content />;
};

export default Timezone;
